const OCCURRENCES_PER_YEAR = {
    weekly: 52,
    fortnightly: 26,
    monthly: 12,
    quarterly: 4,
    yearly: 1,
};
/** The monthly-equivalent of an amount that recurs at the given frequency. */
export function monthlyEquivalent(amount, frequency) {
    return Math.round((amount * OCCURRENCES_PER_YEAR[frequency]) / 12);
}
//# sourceMappingURL=frequency.js.map